import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    fetchLedmoduleProperties, fetchLedmoduleFeatures,
} from '../../../../../actions';
import LedmoduleFeatureList from './LedmoduleFeatureList';
import LedmoduleFeature from './LedmoduleFeature';
import LedmoduleInfo from './LedmoduleInfo';
// import LedmodulePlaceholder from '../../LedmodulePlaceholder';
import { insertPropertiesInFeatures } from '../../../../../utils/driverUtils';

class LedmoduleDriver extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showedFeature: null,
            features: null,
            driver: null,
            ledmodule: null,
            ledmoduleProperties: null,
            isShowingDriverAdd: false,
        };

        this.onShowFeature = this.onShowFeature.bind(this);
        this.handleChangeLedmoduleInfo = this.handleChangeLedmoduleInfo.bind(this);
    }

    componentDidMount() {

        this.props.fetchLedmoduleFeatures(this.props.ledmoduleType).then(() =>{
            this.setState({ showedFeature: this.props.ledmoduleFeatures.length > 0 ? this.props.ledmoduleFeatures[0] : null });
        })
        this.props.fetchLedmoduleProperties(this.props.ledmodule.id);
    }

    static getDerivedStateFromProps(props, state) {

        const newState = {};

        if (props.ledmodule && !state.ledmodule) {
            newState.ledmodule = Object.assign({}, props.ledmodule);
        }

        if (props.ledmoduleFeatures && props.ledmoduleProperties) {
            newState.driverFeatureWithProperties = insertPropertiesInFeatures(props.ledmoduleFeatures, props.ledmoduleProperties, props.ledmodule.type);
        }

        if (Object.keys(newState).length > 0) {
            return newState;
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.ledmoduleType !== prevProps.ledmoduleType) {
            this.props.fetchLedmoduleFeatures(this.props.ledmoduleType).then(() =>{
                this.setState({ showedFeature: this.props.ledmoduleFeatures.length > 0 ? this.props.ledmoduleFeatures[0] : null });
            })
        }
    }


    handleChangeLedmoduleInfo(event) {

        // let prop = this.state[event.target.name];
        // prop[event.target.id] = event.target.value;
        // this.setState({ [event.target.name]: prop });

        this.props.handleChangeLedmoduleInfo(event);
    }

    onShowFeature(e, driverFeature) {

        if (e.target.type === 'checkbox') {
            return;
        }

        e.preventDefault();

        this.setState({
            showedFeature: driverFeature
        });
    }

    render() {

        return (
            <div>
                <Row className="row-ledmodule-info">
                    <Col sm={12}>
                        <LedmoduleInfo
                            handleChange={this.handleChangeLedmoduleInfo}
                            ledmodule={this.props.ledmodule}
                            ledmoduleName={this.props.ledmoduleName}
                            ledmoduleDescription={this.props.ledmoduleDescription}
                            ledmoduleType={this.props.ledmoduleType}
                            disabled={this.props.disabledDriver}
                            errors={this.props.ledmoduleErrors} />
                    </Col>
                </Row>
                <Row className="row-ledmodule-feature-list">
                    <Col sm={2} style={{ paddingRight: '0' }}>
                        <LedmoduleFeatureList
                            showedFeature={this.state.showedFeature}
                            onShowFeature={this.onShowFeature}
                            ledmoduleFeatures={this.props.ledmoduleFeatures}
                            ledmoduleProperties={this.props.ledmoduleProperties}
                            driverFeatureWithProperties={this.state.driverFeatureWithProperties}
                            {...this.props} />
                    </Col>
                    <Col sm={10} style={{ paddingLeft: '0' }} className={this.props.disabledClassName}>
                        <LedmoduleFeature
                            ledmodule={this.props.ledmodule}
                            driver={this.props.driver}
                            feature={this.state.showedFeature}
                            properties={this.props.ledmoduleProperties}
                            handleChangeDriverProperties={this.props.handleChangeDriverProperties} />
                    </Col>
                </Row>
            </div>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        ledmoduleFeatures: state.ledmodule.features,
    };
};

const mapDispatchToProps = {
    fetchLedmoduleFeatures,
    fetchLedmoduleProperties,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LedmoduleDriver);